import axios from 'axios';
import { Store } from 'vuex';
import { RootStoreState } from '@/store';
import { AppConfig } from './types';

const appConfigFileUrl = '/static/ssc-config.json';

class AppConfigService {
  get(): Promise<AppConfig> {
    return axios.get<AppConfig>(appConfigFileUrl, {
      responseType: 'json',
      params: {
        t: Date.now(),
      },
    })
      .then((response) => {
        if (response.data && response.status === 200) {
          return new Promise<AppConfig>((resolve) => {
            setTimeout(
              () => {
                resolve(response.data);
              },
              1,
            );
          });
        }
        throw new Error(`The response for AppConfig is invalid: statusCode[${response.status}]`);
      });
  }

  private syncHandle: any = null;

  periodicSync(store: Store<RootStoreState>, wait: number = 120) {
    const self = this;
    function syncNow() {
      function nextRun() {
        self.syncHandle = setTimeout(
          syncNow,
          wait * 1000,
        );
      }
      store.dispatch('syncAppConfig')
        .then(nextRun, nextRun);
    }
    this.stopPeriodicSync();
    syncNow();
  }

  stopPeriodicSync() {
    if (this.syncHandle) {
      clearTimeout(this.syncHandle);
      this.syncHandle = null;
    }
  }
}

export default new AppConfigService();
